import { Content, ContentCategory, ContentType } from './ContentTypes';

export type ProductRelevantContentProps = {
  content: Array<Content>;
  collapsible: boolean;
  collapsed?: boolean;
  title?: string;
  types: Array<ContentType>;
  categories: Array<ContentCategory>;
  analyticsBannerId?: string;
  contentHelpMeChooseFeature: string;
  contentTechnicalFeature: string;
  typePlaceholderFallback: string;
  contentInspirationFeature: string;
  placeholderTypes: Array<string>;
  timestamp: number;
};
